"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetadataCues = void 0;
var react_1 = require("@xstate/react");
var selectors_1 = require("../selectors");
var lodash_1 = require("lodash");
var video_context_1 = require("../context/video-context");
/**
 * This is a wrapper around xStates useSelector because we want to have
 * a "better" comparison using lodash's isEqual which does a deeper compare
 * between the prev/next values of the cues array from our selectCues
 * selector
 */
var useMetadataCues = function () {
    var videoService = (0, video_context_1.useVideo)();
    return (0, react_1.useSelector)(videoService, selectors_1.selectCues, function (prev, next) {
        return (0, lodash_1.isEqual)(prev, next);
    });
};
exports.useMetadataCues = useMetadataCues;
